<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { offerAlertDescriptor } from 'dashboard/helper/lais/offerPresenter';

const props = defineProps({
  offer: { type: Object, default: null },
});

const { t } = useI18n();

const descriptor = computed(() => offerAlertDescriptor(props.offer || {}));
const variantClasses = computed(() =>
  descriptor.value?.kind === 'critical'
    ? 'border-lais-danger/30 bg-rose-50 text-lais-danger'
    : 'border-lais-success/30 bg-emerald-50 text-emerald-700'
);
const title = computed(() => {
  if (descriptor.value?.kind === 'critical') {
    return t('PROPERTIES.OFFERS.ALERT.CANCELED_TITLE');
  }
  return t('PROPERTIES.OFFERS.ALERT.FINISHED_TITLE');
});
const message = computed(() => {
  if (descriptor.value?.kind === 'critical') {
    return t('PROPERTIES.OFFERS.ALERT.CANCELED_MESSAGE');
  }
  return t('PROPERTIES.OFFERS.ALERT.FINISHED_MESSAGE');
});
</script>

<template>
  <div>
    <section
      v-if="descriptor"
      :role="descriptor.kind === 'critical' ? 'alert' : 'status'"
      :aria-live="descriptor.kind === 'critical' ? 'assertive' : 'polite'"
      aria-atomic="true"
      class="rounded-lais border px-4 py-3"
      :class="variantClasses"
    >
      <p class="text-lais-label-sm font-semibold">
        {{ title }}
      </p>
      <p class="mt-1 text-lais-body-sm">
        {{ message }}
      </p>
    </section>
  </div>
</template>
